import Immutable, { List } from 'immutable';
import { Markup, RawMarkup } from 'records/Markup';
import { NewRFIForwardActivity } from 'records/NewRFIForwardActivity';
import { ProjectDriveSelectedItem } from 'records/ProjectDriveSelectedItem';
import { RawRFI, RFI, StudioData } from 'records/RFI';
import { RawRFIAnswer, RFIAnswer } from 'records/RFIAnswer';
import { RFIFile } from 'records/RFIFile';
import { StudioProjectFileData } from 'records/StudioProjectFile';

export interface RawViewRFI {
  type: string;
  rfi: RawRFI;
  markup: RawMarkup | null;
  expanded: boolean;
  responding: boolean;
  placing: boolean;
  containerStyles: React.CSSProperties;
  answer: RawRFIAnswer;
  canExpand: boolean;
  backArrow: boolean;
  files: Immutable.List<RFIFile>;
  projectDriveItems: ProjectDriveSelectedItem[];
  studioItems: StudioProjectFileData[];
  studioData: StudioData;
  forwardList: Immutable.OrderedSet<string>;
  forwardActivity: NewRFIForwardActivity;
}

export interface ViewRFIData {
  type: string;
  rfi: RFI;
  markup: Markup | null;
  expanded: boolean;
  responding: boolean;
  placing: boolean;
  containerStyles: React.CSSProperties;
  answer: RFIAnswer;
  canExpand: boolean;
  backArrow: boolean;
  files: Immutable.List<RFIFile>;
  projectDriveItems: List<ProjectDriveSelectedItem>;
  studioItems: List<StudioProjectFileData>;
  studioData: StudioData;
  forwardList: Immutable.OrderedSet<string>;
  forwardActivity: NewRFIForwardActivity;
}

const defaultValues: ViewRFIData = {
  type: 'ViewRFI',
  rfi: new RFI(),
  markup: null,
  expanded: false,
  placing: false,
  containerStyles: {},
  responding: false,
  answer: new RFIAnswer(),
  canExpand: false,
  backArrow: false,
  files: Immutable.List<RFIFile>(),
  projectDriveItems: List(),
  studioItems: List(),
  studioData: {
    studioSelectedFolders: [],
    selectedProject: '',
    studioCurrentProjectId: '',
    studioFolderParentId: '',
  },
  forwardList: Immutable.OrderedSet<string>(),
  forwardActivity: new NewRFIForwardActivity(),
};

export const ViewRFIFactory = Immutable.Record(defaultValues, 'ViewRFI');

export class ViewRFI extends ViewRFIFactory {
  serialize(): RawViewRFI {
    return this.toJS();
  }

  static deserialize(rawViewRFI: RawViewRFI): ViewRFI {
    const markup =
      rawViewRFI.markup === null ? null : Markup.deserialize(rawViewRFI.markup);

    return new ViewRFI({
      ...rawViewRFI,
      markup,
      rfi: RFI.deserialize(rawViewRFI.rfi),
      answer: RFIAnswer.deserialize(rawViewRFI.answer),
      projectDriveItems: List(rawViewRFI.projectDriveItems),
      studioItems: List(rawViewRFI.studioItems),
      forwardList: Immutable.OrderedSet<string>(rawViewRFI.forwardList),
    });
  }
}
